var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcononly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 32 32",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "current",
    stroke: "current",
    style: {
      fillOpacity: 1,
      strokeLinejoin: "round"
    },
    d: "M 28,4 C 27,3 8.7466637,6.3483154 4,14 2.0638719,17.121065 2.9956458,22.230465 5.34375,25.242188 L 9,21.585938 V 14 c 0,-0.552285 0.4477153,-1 1,-1 0.552285,0 1,0.447715 1,1 v 5.585938 l 4,-4 v -3.578126 c 0,-0.552285 0.447715,-1 1,-1 0.552285,0 1,0.447715 1,1 v 1.578126 l 4.292969,-4.2929692 c 0.390507,-0.3904233 1.023555,-0.3904233 1.414062,0 0.390423,0.390507 0.390423,1.0235552 0,1.4140622 L 18.414062,15 h 1.59961 0.01172 c 1.314609,0.01859 1.314609,1.981408 0,2 h -0.01172 -3.59961 l -4,4 H 18 c 0.552285,0 1,0.447715 1,1 0,0.552285 -0.447715,1 -1,1 H 10.414062 L 6.7524414,26.661621 C 9.7743347,29.059234 14.815165,29.95839 18,28 25.636655,23.304143 29,5 28,4 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcononly);
export default __webpack_public_path__ + "static/media/logo_icononly.6d4b6437f92d3ee54acc7e523dc0aaa3.svg";
export { ForwardRef as ReactComponent };